import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ResponsiveScreenService {

    public currentBreakpoint = '';
    public breakpoints = {
        '4K': { max: Infinity, min: 1550 },
        '4K-s': { max: 1550, min: 1280 },
        HD: { max: 1280, min: 1050 },
        'HD-s': { max: 1050, min: 770 },
        m: { max: 770, min: 600 },
        s: { max: 600, min: 520 },
        xs: { max: 520, min: 0 }
    };

    constructor() {
        this.initWindowResizeListener();
        this.updateCurrentBreakpoint();
    }

    private initWindowResizeListener(): void {
        window.addEventListener('resize', () => {
            this.updateCurrentBreakpoint();
        });
    }

    private updateCurrentBreakpoint(): void {
        const windowWidth = window.innerWidth;
        const keys = Object.keys(this.breakpoints);
        keys.forEach(key => {
            if (windowWidth < this.breakpoints[key].max && windowWidth >= this.breakpoints[key].min) {
                this.currentBreakpoint = key;
                return;
            }
        });
    }

    public isOrSmaller(breakpoint: string): boolean {
        if (breakpoint === this.currentBreakpoint) {
            return true;
        }
        const targetBreakpoint = this.breakpoints[breakpoint];
        if (!targetBreakpoint) { return false; }

        const windowWidth = window.innerWidth;
        return windowWidth < targetBreakpoint.max;
    }

    public isOrBigger(breakpoint: string): boolean {
        if (breakpoint === this.currentBreakpoint) { return true; }
        const targetBreakpoint = this.breakpoints[breakpoint];
        if (!targetBreakpoint) { return false; }

        const windowWidth = window.innerWidth;
        return windowWidth >= targetBreakpoint.min;
    }
}
